import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  sendResetPasswordEmail,
  verifyOTP,
} from "../../redux/features/authSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, error } = useSelector((state) => state.auth);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [emailError, setEmailError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [success, setSuccess] = useState(false);

  const validateEmail = (email) => {
    const trimmedEmail = email.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail) ? trimmedEmail : "";
  };

  const validateOtp = (otp) => {
    const trimmedOtp = otp.trim();
    return /^\d{6}$/.test(trimmedOtp) ? trimmedOtp : "";
  };

  const handleSendOTP = (e) => {
    e.preventDefault();
    const validEmail = validateEmail(email);
    if (!validEmail) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    setEmailError("");
    dispatch(sendResetPasswordEmail({ email: validEmail }))
      .unwrap()
      .then((res) => {
        setSuccess(true);
        toast.success("OTP send successfully", {
          position: "top-right",
          autoClose: 3000, // Toast will disappear after 5 seconds
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((err) => {
        console.log("Otp Error", err);
        setSuccess(false);
      });
  };

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    const validOtp = validateOtp(otp);
    if (!validOtp) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }
    setOtpError("");
    dispatch(verifyOTP({ email, otp: Number(validOtp) })).then((action) => {
      if (action.type === "auth/verifyOTP/fulfilled") {
        setSuccess(false);
        navigate("/resetpassword", { state: { email } });
      }
    });
  };

  return (
    <div>
      <main className="main pages">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span /> Pages <span /> My Account
            </div>
          </div>
        </div>
        <div className="page-content pt-50 pb-150">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-12 m-auto">
                <div className="login_wrap widget-taber-content background-white">
                  <div className="padding_eight_all bg-white">
                    <div className="heading_s1">
                      <img
                        className="border-radius-15"
                        src="././assets/imgs/page/forgot_password.svg"
                        alt=""
                      />
                      <h2 className="mb-15 mt-15">Forgot your password?</h2>
                      <p className="mb-30">
                        Not to worry, we got you! Let’s get you a new password.
                        Please enter your email address.
                      </p>
                    </div>
                    <form>
                      <div className="form-group">
                        <input
                          type="email"
                          required
                          name="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Email *"
                          disabled={success}
                        />
                        {emailError && (
                          <div className="text-danger">{emailError}</div>
                        )}
                      </div>
                      {success && (
                        <div className="form-group">
                          <input
                            type="text"
                            required
                            name="otp"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter OTP *"
                          />
                          {otpError && (
                            <div className="text-danger">{otpError}</div>
                          )}
                        </div>
                      )}
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn btn-fill-out btn-block hover-up font-weight-bold"
                          onClick={success ? handleVerifyOTP : handleSendOTP}
                          disabled={isLoading}
                        >
                          {isLoading
                            ? "Processing..."
                            : success
                            ? "Verify OTP"
                            : "Send OTP"}
                        </button>
                      </div>
                      {error && <div className="text-danger">{error}</div>}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ForgotPassword;
